// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xoKyCMyOwY {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.xoKyCMyOwY h4 {
  line-height: 3em;
}
.xoKyCMyOwY ._ER9SLncvM {
  float: left;
  width: 100%;
}
.xoKyCMyOwY .It3JWejYD3 {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.xoKyCMyOwY .It3JWejYD3:hover {
  cursor: pointer;
}
.xoKyCMyOwY .It3JWejYD3:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.y94wJNrcmE .ho2E6sY0hH:focus {
  outline: none;
}
.y94wJNrcmE .ho2E6sY0hH.PQLAVqPscD.JLPImu7mvQ {
  background: #375A88;
}
.y94wJNrcmE .ho2E6sY0hH.PQLAVqPscD.JLPImu7mvQ span {
  color: #fff;
}
.y94wJNrcmE .JLPImu7mvQ {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.y94wJNrcmE .JLPImu7mvQ:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.y94wJNrcmE input {
  height: 38px;
  min-width: 220px;
}
.It3JWejYD3.OP8PZ4Kt2X {
  background: #410102;
}
.It3JWejYD3.DEXvgaNlM7 {
  background: #911318;
}
.It3JWejYD3.Gty2fKCLjm {
  background: #D8293B;
}
.It3JWejYD3.aivyqUixMi {
  background: #F2373C;
}
.It3JWejYD3.hJ5jPHAuJR {
  background: #FC4448;
}
.It3JWejYD3.cNh_QYjcQ2 {
  background: #ED535E;
}
.It3JWejYD3.qpLEjK2tY3 {
  background: #E34926;
}
.It3JWejYD3.oKsf6tn8xv {
  background: #FC562B;
}
.It3JWejYD3.GhSaNcP0bA {
  background: #FC6722;
}
.It3JWejYD3.ZHJpSOPbRJ {
  background: #FD7F24;
}
.It3JWejYD3.kfhypFd5pu {
  background: #FD8D26;
}
.It3JWejYD3.ljFaSumbVL {
  background: #EC9C3E;
}
.It3JWejYD3.W2JEelilLy {
  background: #0e673a;
}
.It3JWejYD3.A7g3Q65xUe {
  background: #208740;
}
.It3JWejYD3.gzp285oa4t {
  background: #239718;
}
.It3JWejYD3.XLK7tx7apb {
  background: #55A84D;
}
.It3JWejYD3.OVtOOeuBUR {
  background: #4BBE5A;
}
.It3JWejYD3.sfP6lGVw8a {
  background: #0CCA6A;
}
.It3JWejYD3.qlV24FQNlq {
  background: #0A3C64;
}
.It3JWejYD3.Zb77JneUn4 {
  background: #0d487a;
}
.It3JWejYD3.zwln1yq1Fy {
  background: #10538d;
}
.It3JWejYD3.ziqP5dX3nV {
  background: #115A99;
}
.It3JWejYD3.EwYnjKOsT9 {
  background: #3387E2;
}
.It3JWejYD3.ZZuyBzenJ2 {
  background: #1BA9CF;
}
.It3JWejYD3.VbtBO_Z6Kn {
  background: #d27c02;
}
.It3JWejYD3.hjN4YESpNi {
  background: #fb9402;
}
.It3JWejYD3.mvywJivMcI {
  background: #FD9B30;
}
.It3JWejYD3.lG68Nn1HOP {
  background: #FDBE2D;
}
.It3JWejYD3.BkeHnF8wv8 {
  background: #FED831;
}
.It3JWejYD3.tF63Q0SaEQ {
  background: #FFFD38;
}
.It3JWejYD3.wylcfJ_j7M {
  background: #2D215C;
}
.It3JWejYD3.dkaRLKe4wf {
  background: #483C83;
}
.It3JWejYD3.JLxfoeVz7V {
  background: #58518d;
}
.It3JWejYD3.eLusXgc_Xw {
  background: #7068A9;
}
.It3JWejYD3.gYMdRgNFVB {
  background: #7f78b2;
}
.It3JWejYD3.g18rTwoYX2 {
  background: #8f88bc;
}
.It3JWejYD3.LTwU2ScWp6 {
  background: #000;
}
.It3JWejYD3.Ih1h9Je7AT {
  background: #282626;
}
.It3JWejYD3.In8QvDjwfq {
  background: #242222;
}
.It3JWejYD3.Uz1SCCisHK {
  background: #353838;
}
.It3JWejYD3.D63J4owHpz {
  background: #666;
}
.It3JWejYD3.tM0Ib_3lio {
  background: #999;
}
.qRKCo1q7sy {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.qRKCo1q7sy .cLuXGc7Gyl {
  display: none;
}
.zUeenTsj6_.zUeenTsj6_ {
  width: auto;
  max-width: 600px;
}
.zUeenTsj6_.zUeenTsj6_ .A1qYXQ7UCf {
  position: relative;
  background-color: #375A87;
}
.zUeenTsj6_.zUeenTsj6_ .A1qYXQ7UCf public-link-modal-header__ctn public-link-modal-header__title {
  font-size: 20px;
}
.zUeenTsj6_.zUeenTsj6_ .g8R4f3jckC {
  margin-right: 2px;
  font-size: 20px;
}
.zUeenTsj6_.zUeenTsj6_ .F4Ly5xvxlC {
  position: absolute;
  top: 12px;
  right: 18px;
}
.zUeenTsj6_.zUeenTsj6_ .plB4MIZ05r {
  display: flex;
  margin: 8px 0;
  column-gap: 8px;
}
.zUeenTsj6_.zUeenTsj6_ .plB4MIZ05r .vFvnilViHZ {
  width: 100%;
}
.Ena6ZvTNO3 {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.Ena6ZvTNO3::-webkit-scrollbar {
  display: none;
}
.I1RUkCQLAn {
  display: flex;
  align-items: center;
  padding: 16px;
  justify-content: center;
}
.XzDHMKFq2T .ZQMfvZ8ryX {
  line-height: 15px;
  margin-bottom: 12px;
}
.XzDHMKFq2T .wlFPFR4B7n {
  min-width: 800px;
  padding: 12px 20px 12px;
  width: 100%;
}
.XzDHMKFq2T .dLrqan4au5 {
  width: 728px;
}
.XzDHMKFq2T .RsjRQlh2ng,
.XzDHMKFq2T .RsjRQlh2ng {
  background: none;
}
.XzDHMKFq2T .RsjRQlh2ng > div:first-child,
.XzDHMKFq2T .RsjRQlh2ng > div:first-child {
  font-size: 11px;
  font-style: normal;
  margin-left: 12px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `xoKyCMyOwY`,
	"color-row": `_ER9SLncvM`,
	"color-tile": `It3JWejYD3`,
	"picker-component": `y94wJNrcmE`,
	"picker-element": `ho2E6sY0hH`,
	"active": `PQLAVqPscD`,
	"btn": `JLPImu7mvQ`,
	"red-1": `OP8PZ4Kt2X`,
	"red-2": `DEXvgaNlM7`,
	"red-3": `Gty2fKCLjm`,
	"red-4": `aivyqUixMi`,
	"red-5": `hJ5jPHAuJR`,
	"red-6": `cNh_QYjcQ2`,
	"orange-1": `qpLEjK2tY3`,
	"orange-2": `oKsf6tn8xv`,
	"orange-3": `GhSaNcP0bA`,
	"orange-4": `ZHJpSOPbRJ`,
	"orange-5": `kfhypFd5pu`,
	"orange-6": `ljFaSumbVL`,
	"green-1": `W2JEelilLy`,
	"green-2": `A7g3Q65xUe`,
	"green-3": `gzp285oa4t`,
	"green-4": `XLK7tx7apb`,
	"green-5": `OVtOOeuBUR`,
	"green-6": `sfP6lGVw8a`,
	"blue-1": `qlV24FQNlq`,
	"blue-2": `Zb77JneUn4`,
	"blue-3": `zwln1yq1Fy`,
	"blue-4": `ziqP5dX3nV`,
	"blue-5": `EwYnjKOsT9`,
	"blue-6": `ZZuyBzenJ2`,
	"yellow-1": `VbtBO_Z6Kn`,
	"yellow-2": `hjN4YESpNi`,
	"yellow-3": `mvywJivMcI`,
	"yellow-4": `lG68Nn1HOP`,
	"yellow-5": `BkeHnF8wv8`,
	"yellow-6": `tF63Q0SaEQ`,
	"purple-1": `wylcfJ_j7M`,
	"purple-2": `dkaRLKe4wf`,
	"purple-3": `JLxfoeVz7V`,
	"purple-4": `eLusXgc_Xw`,
	"purple-5": `gYMdRgNFVB`,
	"purple-6": `g18rTwoYX2`,
	"black-1": `LTwU2ScWp6`,
	"black-2": `Ih1h9Je7AT`,
	"black-3": `In8QvDjwfq`,
	"black-4": `Uz1SCCisHK`,
	"black-5": `D63J4owHpz`,
	"black-6": `tM0Ib_3lio`,
	"picker-theme": `qRKCo1q7sy`,
	"arrow-regular": `cLuXGc7Gyl`,
	"public-link-modal__root": `zUeenTsj6_`,
	"public-link-modal-header__root": `A1qYXQ7UCf`,
	"public-link-modal-header__icon": `g8R4f3jckC`,
	"public-link-modal-header__closeBtn": `F4Ly5xvxlC`,
	"public-link-modal__actions": `plB4MIZ05r`,
	"public-link-modal-action__input": `vFvnilViHZ`,
	"public-link-modal__body": `Ena6ZvTNO3`,
	"public-link-modal-content__root": `I1RUkCQLAn`,
	"public-link-project-select": `XzDHMKFq2T`,
	"review-select__label": `ZQMfvZ8ryX`,
	"review-select__root": `wlFPFR4B7n`,
	"review-select__menuCtn": `dLrqan4au5`,
	"review-select__selectContainer": `RsjRQlh2ng`
};
export default ___CSS_LOADER_EXPORT___;
